module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjAgMAAADyVVYGAAAACVBMVEX/zgDdAAAAAAALoL9/AAAAKElEQVRIx+3JMQ0AMAgAsIkcHgkqUcBF+Nq3rwZpjFlMDL4xZjHAgQYhcDWSxA43vQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Germany.png
// module id = 576
// module chunks = 0